import $ from 'jquery';

import MobileNavigation from './MobileNavigation';
import MegaNavigation from './MegaNavigation';

export default class Navigation {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    $('.dropdown', this.el).on('mouseenter.navigation', this.establishTierDirection.bind(this));
    $('.has-mega-nav', this.el).on('mouseenter.navigation', this.toggleMegaNav.bind(this));
    $('[aria-haspopup]', this.el).on('mouseenter.navigation', this.setExpanded.bind(this));
    $('[aria-haspopup]', this.el).on('mouseleave.navigation', this.unsetExpanded.bind(this));
    $(document).on('format-full-navigation.navigation', this.formatFullNavigation.bind(this));

    return this._validate();
  }

  setExpanded(e) {
    const $link = $(e.currentTarget, this.el);

    $link.attr('aria-expanded', true);
  }

  unsetExpanded(e) {
    const $link = $(e.currentTarget, this.el);

    if ($link.hasClass('has-mega-nav')) {
      return;
    }

    $link.attr('aria-expanded', false);
  }

  _validate() {
    this.$mainHeader = $('.main-header', this.el);
    this.navigation = this.$mainHeader.find('nav.full');
    this.megaNavButton = this.navigation.find('.has-mega-nav');
    this.mainMenuNavItems = this.navigation.find('> ul > .nav-item');
    this.multiLine = false;

    this.checkIfFontsLoaded();

    this.requiredRoom = 0;
    for (let i = 0; i < this.mainMenuNavItems.length; i++) {
      const $navItem = $(this.mainMenuNavItems[i]);
      this.requiredRoom += $navItem.outerWidth();
    }

    this.mobileNavigation = new MobileNavigation({ el: '.main-header' });

    // Create meganavs
    this.megaNavs = [];
    $('.mega-nav').each((index, el) => {
      const $el = $(el);
      const megaNav = new MegaNavigation({ el: $el });
      this.megaNavs.push({ $el, object: megaNav, id: $el.attr('id') });
    });

    this.megaNavs.forEach((nav) => {
      nav.$el.on('closeMegaNav.nav', () => {
        $(`.dropdown[aria-controls='${nav.id}']`).attr('aria-expanded', false);
      });
    });

    $(window).resize(() => this.resize());
  }

  checkIfFontsLoaded() {
    let hasRun = 0;

    this.checker = setInterval(() => {
      hasRun += 1;
      if ($('html').hasClass('wf-active') || (hasRun === 10)) {
        this.formatFullNavigation();
        clearInterval(this.checker);
      }
    }, 500);
  }

  resize() {
    return this.formatFullNavigation();
  }

  formatFullNavigation() {
    if (this.navigation.hasClass('main-header--nav-compressed')) { return; }
    const availableRoom = this.navigation.width();

    if (this.requiredRoom >= availableRoom) {
      this.navigation.addClass('compress');
      if (this.navigation.height() > 100) {
        this.multiLine = true;
        this.navigation.addClass('multi-line');
      } else {
        this.navigation.removeClass('multi-line');
        this.multiLine = false;
      }
    } else {
      this.navigation.removeClass('compress');
      this.navigation.removeClass('multi-line');
      this.multiLine = false;
    }

    this.$mainHeader.trigger('position-body-offset');

    $(document).trigger('navigation-resize');
  }

  establishTierDirection(e) {
    this.mainHeaderWrap = $('.main-header-wrap', this.el);
    const dropdown = $(e.currentTarget);
    const children = dropdown.find('.child');
    const tertiaryChildren = children.filter('.tertiary');
    const childWidth = dropdown.find('.dropdown-wrap').outerWidth();
    const positionLeft = dropdown.position().left;
    const requiredRoom = (tertiaryChildren.length > 0) ? (3 * childWidth) : (2 * childWidth);
    const availableRoom = $(window).width() - positionLeft - dropdown.outerWidth();

    if (requiredRoom > availableRoom) {
      children.removeClass('right').addClass('left');
    } else {
      children.removeClass('left').addClass('right');
    }

    // Close other meganavs
    return this.megaNavs
      .filter(nav => dropdown.attr('aria-controls') !== nav.$el.attr('id'))
      .forEach(nav => nav.$el.trigger('dismissMegaNav'));
  }

  toggleMegaNav(e) {
    const $target = $(e.currentTarget);
    if ($target.hasClass('active')) { return; }

    this.megaNavs
      .filter(nav => $target.attr('aria-controls') === nav.$el.attr('id'))
      .forEach(nav => nav.object.toggle());
  }

  unload() {
    this.mobileNavigation.unload();
    this.megaNavs.forEach((nav) => {
      nav.$el.off('.nav');
      nav.object.unload();
    });
    clearInterval(this.checker);
    $('.dropdown', this.el).off('mouseenter.navigation');
    $('.has-mega-nav', this.el).off('mouseenter.navigation');
    $('[aria-haspopup]', this.el).off('mouseenter.navigation');
    $('[aria-haspopup]', this.el).off('mouseleave.navigation');
    $(document).off('format-full-navigation.navigation');
  }
}
